import * as React from 'react';

export const LoadingSpinner: React.FC = () => (
  <div className="loading-wrapper">
    <div className="loading-spinner" />
  </div>
);
